import { defineFetch } from 'resift';

const makeGetRootNodes = defineFetch({
  displayName: 'Get Root Nodes',
  make: () => ({
    request: () => ({ http }) =>
      http({
        method: 'POST',
        route: '/search/people',
        data: {
          filter: {
            and: [
              { field: 'reportingPath', comparison: 'ukn' },
              { field: 'isTeamLeader', comparison: 'eq', value: 'true' },
            ],
          },
          sortBy: 'totalReportCount',
          sortDirection: 'desc',
        },
      }),
  }),
});

const getRootNodes = makeGetRootNodes();

export default getRootNodes;
